<template>
    <div id="app">
    	<notifications group="foo" position="bottom right" style="z-index: 99999999999999;"/>
        <router-view />
    </div>
</template>
<script>
	import $ from 'jquery'
	import '../static/website/js/jquery.min.js';
	import '../static/website/js/bootstrap.min.js';
	import '../static/website/js/popper.min.js';
	export default {
	    name: 'App',
	    data() {
	        return {
	            
	        }
	    }
	}
</script>

<style>
	@import '../static/website/css/bootstrap.min.css';
	@import '../static/website/css/icon-style.css';
	@import '../static/website/css/iconmoon-icon.css';
	@import '../static/website/css/style.css';
	@import '../static/website/css/responsive.css';
</style>



// WEBPACK FOOTER //
// src/App.vue